import React, { useEffect, useMemo, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import Select from "react-select";
import { apiAxios } from "../../../../utils/apiAxios";
type RoleKey = "Designer" | "Milling";

// interface PerformanceRow {
//   id: number;
//   name: string;
//   avgCompletionTime: string;
//   slaBreach: number;
//   acceptedOrders: number;
//   rejectedOrders: number;
//   clientRating: number;
//   totalOrders: number;
//   totalRatings: number;
//   role: RoleKey;
// }
interface PerformanceRow {
  userID: number;
  name: string;
  role: string;
  avgCompletionTime: string;
  slaBreach: number;
  acceptedOrders: number;
  rejectedOrders: number;
  clientRating: number;
  totalOrders: number;
  totalRatings: number;
}

interface PerformanceRowWithSrNo extends PerformanceRow {
  srNo: number;
}

interface SelectOption {
  value: string;
  label: string;
}

// const DATA: PerformanceRow[] = [
//   {
//     id: 1,
//     name: "Anny",
//     avgCompletionTime: "2 Days",
//     slaBreach: 45,
//     acceptedOrders: 120,
//     rejectedOrders: 10,
//     clientRating: 4.8,
//     totalOrders: 130,
//     totalRatings: 110,
//     role: "Designer",
//   },
//   {
//     id: 2,
//     name: "gunjan designer",
//     avgCompletionTime: "3 Days",
//     slaBreach: 39,
//     acceptedOrders: 95,
//     rejectedOrders: 8,
//     clientRating: 4.5,
//     totalOrders: 103,
//     totalRatings: 90,
//     role: "Designer",
//   },
//   {
//     id: 3,
//     name: "Suresh Milling",
//     avgCompletionTime: "1 Day",
//     slaBreach: 31,
//     acceptedOrders: 140,
//     rejectedOrders: 5,
//     clientRating: 4.9,
//     totalOrders: 145,
//     totalRatings: 130,
//     role: "Milling",
//   },
//   {
//     id: 4,
//     name: "Kavita Nesting",
//     avgCompletionTime: "2 Days",
//     slaBreach: 21,
//     acceptedOrders: 88,
//     rejectedOrders: 4,
//     clientRating: 4.6,
//     totalOrders: 92,
//     totalRatings: 80,
//     role: "Milling",
//   },
// ];

// const columns: TableColumn<PerformanceRowWithSrNo>[] = [
//   { name: "Sr. No", selector: (row) => row.srNo, width: "90px" },
//   { name: "Name", selector: (row) => row.name, sortable: true },
//   {
//     name: "Average Completion Time",
//     selector: (row) => row.avgCompletionTime,
//     sortable: true,
//     center: true,
//     width: "220px",
//   },
//   {
//     name: "SLA Breach",
//     selector: (row) => row.slaBreach,
//     sortable: true,
//     center: true,
//     width: "160px",
//   },
//   {
//     name: "Accepted Orders",
//     selector: (row) => row.acceptedOrders,
//     sortable: true,
//     center: true,
//     width: "170px",
//   },
//   {
//     name: "Rejected Orders",
//     selector: (row) => row.rejectedOrders,
//     sortable: true,
//     center: true,
//     width: "170px",
//   },
//   {
//     name: "Client Rating",
//     selector: (row) => row.clientRating,
//     sortable: true,
//     center: true,
//     width: "160px",
//   },
//   {
//     name: "Total Number of Orders",
//     selector: (row) => row.totalOrders,
//     sortable: true,
//     center: true,
//     width: "200px",
//   },
//   {
//     name: "Total Number of Ratings",
//     selector: (row) => row.totalRatings,
//     sortable: true,
//     center: true,
//     width: "200px",
//   },
// ];
const columns: TableColumn<PerformanceRowWithSrNo>[] = [
  {
    name: "Sr. No",
    selector: row => row.srNo,
    width: "90px",
  },
  {
    name: "Name",
    selector: row => row.name,
    sortable: true,
  },
  {
    name: "Average Completion Time",
    selector: row => row.avgCompletionTime,
    sortable: true,
  },
  {
    name: "SLA Breach",
    selector: row => row.slaBreach,
  },
  {
    name: "Accepted Orders",
    selector: row => row.acceptedOrders,
  },
  {
    name: "Rejected Orders",
    selector: row => row.rejectedOrders,
  },
  {
    name: "Client Rating",
    selector: row => row.clientRating,
  },
  {
    name: "Total Orders",
    selector: row => row.totalOrders,
  },
  {
    name: "Total Ratings",
    selector: row => row.totalRatings,
  },
];

export default function PerformanceReport() {
  const [designer, setDesigner] = useState<SelectOption | null>(null);
  const [milling, setMilling] = useState<SelectOption | null>(null);
const [data, setData] = useState<PerformanceRow[]>([]);
const [dropdownUsers, setDropdownUsers] = useState<any[]>([]);

useEffect(() => {
  fetchDropdowns();
   fetchPerformanceData();
}, []);
const fetchPerformanceData = async () => {


  try {
    const res = await apiAxios.get("/Rating/PerformanceAnalytics");

    if (res.data.isSuccess) {
      console.log("Performance Data", res.data.singleData);
      setData(res.data.singleData);
      console.log(res,"********");
    }
  } catch (err) {
    console.error(err);
  }
};
const fetchDropdowns = async () => {
  try {
    const res = await apiAxios.get("/Rating/RatingAnalyticsDropdowns");

    if (res.data.isSuccess) {
     
      setDropdownUsers(res.data.singleData);
    }
  } catch (err) {
    console.error(err);
  }
};
 const designerSelectOptions: SelectOption[] = useMemo(
  () =>
    dropdownUsers
      .filter((x: any) => x.roleID === 6)
      .map((x: any) => ({
        value: x.userID.toString(),
        label: x.name,
      })),
  [dropdownUsers]
);

const millingSelectOptions: SelectOption[] = useMemo(
  () =>
    dropdownUsers
      .filter((x: any) => x.roleID === 3)
      .map((x: any) => ({
        value: x.userID.toString(),
        label: x.name,
      })),
  [dropdownUsers]
);

  // const filteredData: PerformanceRowWithSrNo[] = useMemo(() => {
  //   return DATA.filter((row) => {
  //     if (designer && row.role === "Designer" && row.name !== designer.value) {
  //       return false;
  //     }
  //     if (milling && row.role === "Milling" && row.name !== milling.value) {
  //       return false;
  //     }
  //     if (designer && !milling && row.role === "Milling") return false;
  //     if (milling && !designer && row.role === "Designer") return false;
  //     return true;
  //   }).map((row, i) => ({ ...row, srNo: i + 1 }));
  // }, [designer, milling]);
//   const filteredData: PerformanceRowWithSrNo[] = useMemo(() => {
//   return data
//     .filter((row) => {
//       if (
//         designer &&
//         row.role === "Designer" &&
//         row.userID.toString() !== designer.value
//       ) {
//         return false;
//       }

//       if (
//         milling &&
//         row.role === "Milling" &&
//         row.userID.toString() !== milling.value
//       ) {
//         return false;
//       }

//       if (designer && !milling && row.role === "Milling") return false;
//       if (milling && !designer && row.role === "Designer") return false;

//       return true;
//     })
//     .map((row, index) => ({
//       ...row,
//       srNo: index + 1,
//     }));
// }, [data, designer, milling]);

const filteredData: PerformanceRowWithSrNo[] = useMemo(() => {
  return data
    .filter((row) => {
      const selectedIds: string[] = [];

      if (designer) selectedIds.push(designer.value);
      if (milling) selectedIds.push(milling.value);

      // No filters selected
      if (selectedIds.length === 0) return true;

      // Show only selected users
      return selectedIds.includes(row.userID.toString());
    })
    .map((row, index) => ({
      ...row,
      srNo: index + 1,
    }));
}, [data, designer, milling]);
//   const filteredData: PerformanceRowWithSrNo[] = useMemo(
//   () =>
//     data.map((row, index) => ({
//       ...row,
//       srNo: index + 1,
//     })),
//   [data]
// );

  return (
    <div>
      <div className="premium-card mb-4 pb-5">
        <div className="row">
          <div className="col-md-4">
            <label className="mb-2 fw-semibold">Designer</label>
            <Select
              options={designerSelectOptions}
              value={designer}
              onChange={(selected) => setDesigner(selected as SelectOption | null)}
              placeholder="Select Designer"
              isSearchable
              isClearable
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-4">
            <label className="mb-2 fw-semibold">Milling</label>
            <Select
              options={millingSelectOptions}
              value={milling}
              onChange={(selected) => setMilling(selected as SelectOption | null)}
              placeholder="Select Milling"
              isSearchable
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        </div>
      </div>

      <div className="premium-card mt-2">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          responsive
        />
      </div>
    </div>
  );
}
